export const SEARCH_PARAM_OAUTH_CODE_V1 = 'oauth_code_v1' as const;

export const PLATFORM_TYPE = 'platformType';

export const ABTASTY_QA_PLATFORM_URL = 'ABTASTY_QA_PLATFORM_TYPE';

export const FS_TOKEN = 'FS_TOKEN';
